import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import iconPrestamioBlank from '../../assets/icon_prestamio_blank.png';
import iconPrestamio from '../../assets/icon_prestamio.png';
import { useTheme } from '../../context/ThemeContext';

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5"/>
      <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
      <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  );
}

const menuItems = [
  { to: '/superadmin',             label: 'Dashboard',      icon: '📊', end: true },
  { to: '/superadmin/clientes',    label: 'Clientes',       icon: '🏢' },
  { to: '/superadmin/planes',      label: 'Planes',         icon: '💎' },
  { to: '/superadmin/suscripciones', label: 'Suscripciones', icon: '🔑' },
  { to: '/superadmin/pagos',       label: 'Pagos',          icon: '💳' },
  { to: '/superadmin/crm',         label: 'CRM',            icon: '🎯' },
  { to: '/superadmin/reportes',    label: 'Reportes',       icon: '📈' },
];

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useTheme();

  return (
    <div style={{ display: 'flex', height: '100vh', background: 'var(--bg-app)', color: 'var(--text-1s)', fontFamily: 'system-ui,sans-serif' }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 64 : 220,
        background: 'var(--bg-card)',
        borderRight: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.2s',
        overflow: 'hidden',
      }}>
        {/* Logo */}
        <div style={{ height: 48, padding: '0 12px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <img src={isDark ? iconPrestamioBlank : iconPrestamio} alt="Prestam.io" style={{ width: 32, height: 32, flexShrink: 0, objectFit: 'contain' }} />
          {!collapsed && <span style={{ fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap', color: 'var(--text-1)' }}>Prestam.io Admin</span>}
        </div>

        {/* Menu */}
        <nav style={{ flex: 1, padding: '8px 6px', overflowY: 'auto' }}>
          {menuItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '9px 10px', borderRadius: 8, marginBottom: 2,
                textDecoration: 'none', fontSize: 13, fontWeight: 500,
                color: isActive ? '#fff' : '#94a3b8',
                background: isActive ? '#4f46e5' : 'transparent',
                transition: 'all 0.15s',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              })}
            >
              <span style={{ flexShrink: 0, fontSize: 16 }}>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* Bottom */}
        <div style={{ padding: '10px 6px', borderTop: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 4 }}>
          <button
            onClick={() => navigate('/')}
            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, border: 'none', background: 'transparent', color: 'var(--text-3)', cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden' }}
          >
            <span style={{ flexShrink: 0 }}>←</span>
            {!collapsed && <span>Volver a App</span>}
          </button>
          <button
            onClick={() => setCollapsed(c => !c)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, border: 'none', background: 'transparent', color: 'var(--text-3)', cursor: 'pointer', fontSize: 13 }}
          >
            <span>{collapsed ? '→' : '←'}</span>
            {!collapsed && <span>Colapsar</span>}
          </button>
        </div>
      </aside>

      {/* Right panel */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {/* Topbar */}
        <header style={{
          display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
          padding: '0 16px', height: 48, flexShrink: 0,
          background: 'var(--tb-bg)',
          borderBottom: '1px solid var(--tb-border)',
          position: 'sticky', top: 0, zIndex: 100,
        }}>
          <button
            onClick={toggleTheme}
            title={isDark ? 'Modo claro' : 'Modo oscuro'}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'var(--tb-icon-color)',
              padding: '7px 8px', borderRadius: 8,
              display: 'flex', alignItems: 'center',
            }}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
          </button>
        </header>

        {/* Content */}
        <main style={{ flex: 1, overflowY: 'auto', background: 'var(--bg-app)' }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
